import React from 'react';

import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS, fetchAgreements, fetchAgreementTemplates} from 'ducks/bookings';

import {AddAgreementForm, Buttons} from './components';

class AddAgreementModal extends React.Component<any> {
  triggerFormSubmit = () => this.props.submit('addAgreement');

  getExtraActions = () => {
    const {data: {bookingId}} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchAgreements({bookingId})
    ];
  };

  componentDidMount() {
    const {data: {bookingId}} = this.props;

    const fetchAgreementTemplatesExtraActions = this.props.storeDataExtraActions(
      data => ({
        agreementTemplates: data
      })
    );

    this.props.fetchAgreementTemplates(
      {bookingId},
      fetchAgreementTemplatesExtraActions
    );
  }

  render() {
    const {data: {bookingId}, form: {submitting}} = this.props;

    return (
      <Modal
        className="AddAgreementModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Add Agreement" />
        <Modal.Body>
          <AddAgreementForm
            agreementTemplates={this.props.data.agreementTemplates || []}
            getExtraActions={this.getExtraActions}
            bookingId={bookingId}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitButtonDisabled={submitting}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('addAgreement')(state)
  }
});

const mapDispatchToProps = {
  fetchAgreementTemplates,
  submit
};
export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.ADD_AGREEMENT)(AddAgreementModal)
);
